import { OrderStatus } from "@/types/tms";

export function getOrderCardClass(status: OrderStatus): string {
  const statusClasses: Record<OrderStatus, string> = {
    booked: "order-card-booked",
    confirmed: "order-card-confirmed",
    in_transit: "order-card-in-transit",
    delivered: "order-card-delivered",
    canceled: "order-card-canceled",
    tender_received: "order-card-confirmed", // fallback to confirmed style
  };
  
  return statusClasses[status] || "order-card-booked";
}
